export const i18nconfig = () => ({
  supportedLngs: ['en'],
  fallbackLng: 'en',
  defaultNS: 'common',
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
  react: { useSuspense: true },
})